import React, { FC } from 'react'

import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { MediaCardSkeleton } from '@shared/ui/Layout/Cards/MediaCard'

interface Props {
  className?: string
  sizes: string
}

const Skeleton: FC<Props> = (props) => {
  return (
    <ErrorBoundary>
      <MediaCardSkeleton {...props} />
    </ErrorBoundary>
  )
}

export default Skeleton
